import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";


const ScrollToHeaderTitle = () => {
    const location = useLocation();
    const navigationType = useNavigationType();
    const divRef = useRef<HTMLDivElement | null>(null);

    // TODO to be able to check the navigation here by comparing the old path with the new one, we'd need to
    //  store the old path in a useRef, and update that after location has changed. with that we should be able to
    //  detect navigations where only a modal is opened and closed, and skip the scrollIntoView call in such cases.
    useEffect(() => {
        if ((navigationType === 'PUSH' || navigationType === 'REPLACE') && divRef.current) {
            divRef.current.scrollIntoView({behavior: "auto", block: "start" });
        }
    }, [location.pathname, navigationType]);

    return <div ref={divRef} id="title-header"></div>
}

export default ScrollToHeaderTitle;
